<i18n src="./resources/locales.json"></i18n>
<template>
  <div id="chat-url">
    <div>{{ $t('customerAccessUrl') }}</div>
    <v-text-field :value="chatUrl" outlined hide-details readonly>
      <template #append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="copyToClipboard" v-on="on" class="copy-button">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('copyToClipboard') }}</span>
        </v-tooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EcsChatUrls',

  computed: {
    ...mapGetters(['organizationId', 'chatBaseUrl', 'selectedBusinessProcesses']),

    chatUrl() {
      return `${this.chatBaseUrl}/#/?chatIdentifier=${this.organizationId}&chatURI=${this.uri}`;
    },

    uri() {
      return this.selectedBusinessProcesses[0];
    }
  },
  methods: {
    ...mapActions(['createSnackbarMessage']),
    copyToClipboard() {
      const el = document.createElement('input');
      el.value = this.chatUrl;
      el.style.hidden = true;
      document.body.appendChild(el);
      if (document.getSelection().rangeCount > 0) {
        document.getSelection().getRangeAt(0);
      }
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.confirmCopyToClipboard();
    },
    confirmCopyToClipboard() {
      this.createSnackbarMessage({
        message: {
          i18nKey: 'success.copied'
        }
      });
    }
  }
};
</script>

<style>
.chat-url-card {
  width: 60%;
}
#chat-url .v-text-field--enclosed .v-input__append-inner {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>
